import React from 'react';
import styled, { css } from 'styled-components';
import { CardInner } from '../../commons/CardInner';
import { animationShow } from './animations';
var defaultStyles = css(["position:absolute;"]);
var alwaysOpenStyles = css(["position:relative;"]);
var fullWidthStyles = css(["position:absolute;width:100%;"]);
var MenuCard = styled(CardInner).withConfig({
  displayName: "Menu__MenuCard",
  componentId: "sc-cucrrk-0"
})(["", ";"], animationShow);
var Inner = styled.div.withConfig({
  displayName: "Menu__Inner",
  componentId: "sc-cucrrk-1"
})(["", " z-index:30;min-width:280px;margin-top:10px;", ";"], function (_ref) {
  var alwaysOpen = _ref.alwaysOpen,
    fullWidth = _ref.fullWidth;
  if (alwaysOpen) return alwaysOpenStyles;else if (fullWidth) return fullWidthStyles;
  return defaultStyles;
}, function (_ref2) {
  var left = _ref2.left;
  return left ? "left: ".concat(left, "px;") : '';
});
var Content = styled.div.withConfig({
  displayName: "Menu__Content",
  componentId: "sc-cucrrk-2"
})(["padding:8px 12px;"]);
export var Menu = function Menu(_ref3) {
  var children = _ref3.children,
    left = _ref3.left,
    _ref3$fullWidth = _ref3.fullWidth,
    fullWidth = _ref3$fullWidth === void 0 ? false : _ref3$fullWidth,
    _ref3$alwaysOpen = _ref3.alwaysOpen,
    alwaysOpen = _ref3$alwaysOpen === void 0 ? false : _ref3$alwaysOpen;
  return React.createElement(Inner, {
    left: left,
    fullWidth: fullWidth,
    alwaysOpen: alwaysOpen
  }, React.createElement(MenuCard, {
    posX: "bottom",
    posY: left > 0 ? 'right' : 'left'
  }, React.createElement(Content, null, React.createElement("div", null, children))));
};